<gsp-checkbox
    [(value)]="field.required"
    [disabled]="field.locked"
    [id]="field.uuid"
    [label]="'TC.Common.RequiredField' | translate"
></gsp-checkbox>
